import { format, utcToZonedTime } from 'date-fns-tz';
import type { FC } from 'react';

import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';
import { CategoryIdE } from 'declarations/enums/releaseNotes';

import ReleaseNotesLoader from './components/ReleaseNotesLoader';
import useReleasesPage from './hooks/useReleaseNotes';
import {
  CategoryTitleStyled,
  ContainerStyled,
  HeroStyled,
  ListItemStyled,
  MainContainerStyled,
  NotesByDateListItemStyled,
  NotesListStyled,
  ReleaseNotesWrapStyled,
  TypographyStyled,
  VersionStyled,
} from './ReleaseNotes.styled';

const ReleaseNotes: FC = () => {
  const { groupedReleaseNotes, isLoadingGroupedReleaseNotes } = useReleasesPage();

  return (
    <MainContainerStyled>
      <HeroStyled>
        <ContainerStyled>
          <Typography variant="h1" size="lg" color="darkBlue">
            Release Notes
          </Typography>
        </ContainerStyled>
      </HeroStyled>
      <div>
        {isLoadingGroupedReleaseNotes && <ReleaseNotesLoader />}
        <ReleaseNotesWrapStyled>
          <ul>
            {!isLoadingGroupedReleaseNotes &&
              groupedReleaseNotes &&
              groupedReleaseNotes.map(({ releaseDate, version, categorizedNotes }, i) => (
                <NotesByDateListItemStyled key={`groupedReleaseNote-${i}`}>
                  <FlexContainer justify="flex-start" align="center">
                    <Typography variant="h2" color="darkBlue">
                      {format(utcToZonedTime(releaseDate, 'UTC'), 'MMM do, yyyy', {
                        timeZone: 'UTC',
                      })}
                    </Typography>
                    {version && (
                      <VersionStyled variant="body3" color="darkBlue">
                        v{version}
                      </VersionStyled>
                    )}
                  </FlexContainer>
                  <ul>
                    {categorizedNotes.map(({ categoryId, notes }, i) => (
                      <li key={`category-${i}`}>
                        <CategoryTitleStyled variant="h4" color="darkBlue">
                          {categoryId === CategoryIdE.WhatsNew ? "What's new" : 'Fixed issues'}
                        </CategoryTitleStyled>
                        <NotesListStyled>
                          {notes.map(({ id, note, description }) => (
                            <ListItemStyled key={`note-${id}`}>
                              <TypographyStyled variant="body1" color="primaryText">
                                {note}
                              </TypographyStyled>
                              {description && (
                                <TypographyStyled variant="body4" color="primaryText">
                                  {description}
                                </TypographyStyled>
                              )}
                            </ListItemStyled>
                          ))}
                        </NotesListStyled>
                      </li>
                    ))}
                  </ul>
                </NotesByDateListItemStyled>
              ))}
          </ul>
        </ReleaseNotesWrapStyled>
      </div>
    </MainContainerStyled>
  );
};

export default ReleaseNotes;
